/**
 * @ngdoc service
 * @name checkins.factory:archiveSelected
 *
 * @description
 *
 */
angular
    .module('festzelt-os.components')
    .factory('archiveSelected', [
        archiveSelected
    ]);

function archiveSelected() {
    return {
        key: 'archive-selected',
        title: 'Archive selected',
        level: 'selected',
        manager: 'archiveMany'
    }
}



// WEBPACK FOOTER //
// ./src/app/components/workflows/general/archive-selected.js